import {Vue} from 'ui.vue';


import './BXmakerAuthuserphoneSimplePhone.styl';




/**
 * @emits onClickDone {}
 * @emits onInputPhone {string}
 */
Vue.component('BXmakerAuthuserphoneSimplePhone',
    {
        props: {
            loader: {
                type: Boolean,
                default : false,
            },
            phone: {
                type: [String],
                default : '',
            },
            phoneError: {
                type: [String, Boolean],
                default : false,
            }
        },
        data: function () {
            return {

            };
        },
        computed: {
            buttonText() {
                if (this.$root.confirmType === this.$root.const.CONFIRM_TYPE_SMS_CODE) {
                    return this.$root.localize.BXMAKER_AUTHUSERPHONE_SIMPLE_PHONE_BUTTON_GET_CODE;
                } else {
                    return this.$root.localize.BXMAKER_AUTHUSERPHONE_SIMPLE_PHONE_BUTTON_CONFIRM;
                }
            }
        },
        methods: {
            onInputPhone(value) {
                this.$emit('onInputPhone', value);
            },
            onClickDone() {
                this.$emit('onClickDone');
            },
            onChangePhone(data){
                this.$emit('onInputPhone', data.formattedValue);
            }
        },
        template: `
            <div class="bxmaker-authuserphone-simple-phone">    
                          
                  <slot name="header">
                      <BXmakerAuthuserphoneHeader>
                          {{$root.localize.BXMAKER_AUTHUSERPHONE_SIMPLE_PHONE_TITLE}}                        
                      </BXmakerAuthuserphoneHeader>
                  </slot>
                              
                   <slot name="message" />  
                        <BXmakerAuthuserphoneMessage :message="$root.message" :error="$root.error" />
                   </slot>     
                                 
                       
                    <slot name="phone">                   
                        <BXmakerAuthuserphoneInputPhone  v-if="$root.isEnabledPhoneMask"
                            :title="$root.localize.BXMAKER_AUTHUSERPHONE_SIMPLE_PHONE_INPUT_LABEL" 
                            :value="phone" 
                            @onChange="onChangePhone" 
                            @onEnter="onClickDone" 
                            name="PHONE" 
                            :defaultCountry="$root.phoneMaskDefaultCountry"
                            :countryTopList="$root.phoneMaskCountryTopList"
                            :validationMessage="phoneError"
                        />
                        
                        
                        <BXmakerAuthuserphoneInput v-else
                            :title="$root.localize.BXMAKER_AUTHUSERPHONE_SIMPLE_PHONE_INPUT_LABEL" 
                            :value="phone" 
                            @onInput="onInputPhone" 
                            @onEnter="onClickDone" 
                            name="PHONE" 
                            :validationMessage="phoneError"
                        />
                        
                        
                    </slot>
                    
                     <slot name="captcha">
                        <BXmakerAuthuserphoneCaptcha 
                            :code="$root.captchaCode"
                            :src="$root.captchaSrc"
                            :length="$root.captchaLength"
                            :loader="$root.captchaLoader"
                            @onInput="$root.setCaptchaCode"
                            @onComplete="onClickDone"
                            @onRefresh="$root.refreshCaptcha"
                           />  
                     </slot>   
                     
                    
                     <slot name="request">
                        <BXmakerAuthuserphoneButton 
                            :title="buttonText"  
                            :loader="loader"
                            @onClick="onClickDone" 
                        />
                    </slot>
                    
            </div>   
        `,
    });